import type { FC } from "react";

import { useTrustPilotConfig } from "@ui/hooks/useTrustPilotConfig";
import classNames from "classnames";

import styles from "./TrustPilotMicroReviewCount.module.scss";

type TrustPilotMicroReviewCountProps = {
  className?: string;
  styleHeight?: string;
  styleWidth?: string;
  theme?: string;
  minReviewCount?: string;
  styleAlignment?: string;
};

export const TrustPilotMicroReviewCount: FC<TrustPilotMicroReviewCountProps> = ({
  className,
  styleHeight = "24px",
  styleWidth = "100%",
  theme = "light",
  minReviewCount = "0",
  styleAlignment = "center",
}) => {
  const { ref, isEnabled, localeCode, businessUnitId, templateId, leaveAReviewLink } = useTrustPilotConfig(
    "microReviewCountWidgetTemplateId"
  );

  if (!isEnabled || !leaveAReviewLink) {
    return null;
  }

  return (
    <div
      ref={ref}
      data-testid="trustpilot-micro-review-count"
      className={classNames("trustpilot-widget", styles.widget, className)}
      data-locale={localeCode}
      data-template-id={templateId}
      data-businessunit-id={businessUnitId}
      data-style-height={styleHeight}
      data-style-width={styleWidth}
      data-theme={theme}
      data-min-review-count={minReviewCount}
      data-style-alignment={styleAlignment}
    >
      <a href={leaveAReviewLink} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
